import { action } from 'satcheljs/lib/legacy';
import { ACTION_SELECT_FOCUSED_PIVOT } from '../utils/actionNames';
import { lazyUpdateWatermarkAndReset } from 'mini-mail-focused-inbox-rollup-store';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';

// Select focused pivot
export default action(ACTION_SELECT_FOCUSED_PIVOT)(async function selectFocusedPivot(
    focusedViewFilter: FocusedViewFilter
) {
    // Update last visited watermark for selected pivot and reset rollup store
    lazyUpdateWatermarkAndReset.importAndExecute(focusedViewFilter);
});
